// extracted by mini-css-extract-plugin
export default {"content":"view-feedback-modal_content__S9XIY"};